/**
 * Participant portal (home / profile / help) UI strings.
 * Use: t('participant.someKey')
 */

export const participantEn = {
  language: 'Language',
  langEn: 'EN',
  langEs: 'ES',

  navHome: 'Home',
  navProfile: 'Profile',
  navHelp: 'Help',

  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',

  actionNeeded: 'Action needed',
  flightItinerary: 'Flight itinerary',
  itineraryUploaded: 'Itinerary uploaded',
  uploadYourFlights: 'Upload your flights',

  sectionProfile: 'Profile',
  sectionTravelDocs: 'Travel documents',
  sectionImmigration: 'Immigration',
  sectionProduction: 'Production',

  personalDetails: 'Personal details',
  professionalProfile: 'Professional profile',
  onlineProfiles: 'Online profiles',
  contactDetails: 'Contact details',
  createProfessionalProfile: 'Create your professional profile',
  createProfessionalProfileBody: 'We use this profile to prepare your immigration paperwork. Start with any information you already have.',
  createProfile: 'Create profile',
  editProfile: 'Edit profile',
  passport: 'Passport and identity',
  travelItinerary: 'Travel itinerary',
  otherTravelDocs: 'Other travel documents',
  documentType: 'Document type',
  documentNumber: 'Document number',
  issuingCountry: 'Issuing country',
  issueDate: 'Issue date',
  expirationDate: 'Expiration date',
  addDocument: 'Add document',
  choose: 'Choose',
  selectCountry: 'Select country',
  accompanyingFamily: 'Accompanying family',
  familySpouseChildQuestion: 'Will your spouse or any children travel with you or join you for this project?',
  familyMemberFullName: 'Full name as shown in passport',
  familyMemberDob: 'Date of birth',
  familyMemberNationality: 'Nationality',
  familyMemberRelationship: 'Relationship to you',
  addFamilyMember: 'Add family member',
  yes: 'Yes',
  no: 'No',
  briefDetails: 'Brief details',
  immigrationHistory: 'Immigration history',
  legalHistory: 'Legal history',
  work: 'Work',

  documentCenter: 'Document Center',
  docsProvided: '{{provided}} of {{total}} provided',
  privacyTitle: 'Your information stays protected',
  howWeUseData: 'How we use your data',

  profileTitle: 'Profile',
  account: 'Account',
  nationality: 'Nationality',
  email: 'Email',
  phone: 'Phone',
  howWeReachYou: 'How we reach you',
  emailUpdates: 'Email updates',
  textMessages: 'Text messages',
  keepOneReachMethod: 'Keep at least one way for us to reach you',
  security: 'Security',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  view: 'View',
  logOut: 'Log out',
  edit: 'Edit',
  verify: 'Verify',
  done: 'Done',
  cancel: 'Cancel',
  confirmCode: 'Confirm code',
  verifying: 'Verifying…',
  sending: 'Sending…',
  resendIn: 'Resend in {{seconds}}s',
  resendCode: 'Resend code',
  codeSent: 'Code sent',
  enterCodeSentTo: 'Enter the code sent to',

  helpTitle: 'Help',
  askAtlas: 'Ask Atlas',
  askAtlasSub: 'Instant answers, any time',
  yourTeam: 'Your team',
  yourGmManager: 'Your GM Manager',
  available: 'Available',
  sendMessage: 'Send a message',
  teamNote: 'Reachable anytime. If away, typical reply within a few hours.',
  commonTopics: 'Common topics',
  aboutProcedure: 'About your procedure',
  howTimelinesWork: 'How timelines work',
  documentsTopic: 'Documents',

  productionNda: 'Production NDA',
  continue: 'Continue',
  scanOrUploadPassport: 'Scan or upload passport',
  reviewAndSign: 'Review and sign',
  uploadItinerary: 'Upload itinerary',
  passportActionBody:
    'Upload one PDF containing every page of the passport you will use, including blank pages.',
  passportEveryPage: 'Every page of your passport',
  passportEveryPageBody: 'Include blank pages. Each page must be complete, in focus, and free from glare.',
  scanPassport: 'Scan passport',
  scanPassportHint: 'Use your phone camera',
  uploadPassportPdf: 'Upload passport PDF',
  uploadPassportPdfHint: 'One file containing every page',
  passportExtractionNote:
    "We'll use the passport to fill in the details on the next screens. You can review and correct them.",
  passportAddLaterNote: 'You can also enter your details and add the passport later.',
  passportEnterDetailsWithoutUpload: 'Enter details without uploading',
  passportContinueToDetails: 'Continue to passport details',
  ndaActionBody: 'Review and sign the production NDA.',
  personalActionBody: 'Confirm your applicant details so we can prepare your filing.',
  itineraryActionBody: 'Upload a CSV with your flights, hotel stay, and set call times.',
  ready: 'Ready',
};

export const participantEs = {
  language: 'Idioma',
  langEn: 'EN',
  langEs: 'ES',

  navHome: 'Inicio',
  navProfile: 'Perfil',
  navHelp: 'Ayuda',

  goodMorning: 'Buenos días',
  goodAfternoon: 'Buenas tardes',
  goodEvening: 'Buenas noches',

  actionNeeded: 'Acción necesaria',
  flightItinerary: 'Itinerario de vuelo',
  itineraryUploaded: 'Itinerario subido',
  uploadYourFlights: 'Sube tus vuelos',

  sectionProfile: 'Perfil',
  sectionTravelDocs: 'Documentos de viaje',
  sectionImmigration: 'Inmigración',
  sectionProduction: 'Producción',

  personalDetails: 'Datos personales',
  professionalProfile: 'Perfil profesional',
  onlineProfiles: 'Perfiles en línea',
  contactDetails: 'Datos de contacto',
  createProfessionalProfile: 'Crea tu perfil profesional',
  createProfessionalProfileBody: 'Usamos este perfil para preparar tu documentación de inmigración. Empieza con cualquier información que ya tengas.',
  createProfile: 'Crear perfil',
  editProfile: 'Editar perfil',
  passport: 'Pasaporte e identidad',
  travelItinerary: 'Itinerario de viaje',
  otherTravelDocs: 'Otros documentos de viaje',
  documentType: 'Tipo de documento',
  documentNumber: 'Número de documento',
  issuingCountry: 'País emisor',
  issueDate: 'Fecha de expedición',
  expirationDate: 'Fecha de caducidad',
  addDocument: 'Añadir documento',
  choose: 'Elegir',
  selectCountry: 'Seleccionar país',
  accompanyingFamily: 'Familia acompañante',
  familySpouseChildQuestion: '¿Viajará tu cónyuge o algún hijo contigo o se unirá a este proyecto?',
  familyMemberFullName: 'Nombre completo como figura en el pasaporte',
  familyMemberDob: 'Fecha de nacimiento',
  familyMemberNationality: 'Nacionalidad',
  familyMemberRelationship: 'Relación contigo',
  addFamilyMember: 'Añadir familiar',
  yes: 'Sí',
  no: 'No',
  briefDetails: 'Detalles breves',
  immigrationHistory: 'Historial de inmigración',
  legalHistory: 'Historial legal',
  work: 'Trabajo',

  documentCenter: 'Centro de documentos',
  docsProvided: '{{provided}} de {{total}} aportados',
  privacyTitle: 'Tu información está protegida',
  howWeUseData: 'Cómo usamos tus datos',

  profileTitle: 'Perfil',
  account: 'Cuenta',
  nationality: 'Nacionalidad',
  email: 'Correo',
  phone: 'Teléfono',
  howWeReachYou: 'Cómo te contactamos',
  emailUpdates: 'Actualizaciones por correo',
  textMessages: 'Mensajes de texto',
  keepOneReachMethod: 'Mantén al menos una forma de contactarte',
  security: 'Seguridad',
  privacyPolicy: 'Política de privacidad',
  termsOfService: 'Términos del servicio',
  view: 'Ver',
  logOut: 'Cerrar sesión',
  edit: 'Editar',
  verify: 'Verificar',
  done: 'Listo',
  cancel: 'Cancelar',
  confirmCode: 'Confirmar código',
  verifying: 'Verificando…',
  sending: 'Enviando…',
  resendIn: 'Reenviar en {{seconds}}s',
  resendCode: 'Reenviar código',
  codeSent: 'Código enviado',
  enterCodeSentTo: 'Introduce el código enviado a',

  helpTitle: 'Ayuda',
  askAtlas: 'Pregunta a Atlas',
  askAtlasSub: 'Respuestas al instante, en cualquier momento',
  yourTeam: 'Tu equipo',
  yourGmManager: 'Tu gestor de GM',
  available: 'Disponible',
  sendMessage: 'Enviar un mensaje',
  teamNote: 'Disponible en cualquier momento. Si no está, suele responder en pocas horas.',
  commonTopics: 'Temas frecuentes',
  aboutProcedure: 'Sobre tu procedimiento',
  howTimelinesWork: 'Cómo funcionan los plazos',
  documentsTopic: 'Documentos',

  productionNda: 'NDA de producción',
  continue: 'Continuar',
  scanOrUploadPassport: 'Escanear o subir pasaporte',
  reviewAndSign: 'Revisar y firmar',
  uploadItinerary: 'Subir itinerario',
  passportActionBody:
    'Sube un PDF con todas las páginas del pasaporte que vas a usar, incluidas las en blanco.',
  passportEveryPage: 'Todas las páginas de tu pasaporte',
  passportEveryPageBody: 'Incluye las páginas en blanco. Cada página debe estar completa, enfocada y sin reflejos.',
  scanPassport: 'Escanear pasaporte',
  scanPassportHint: 'Usa la cámara del teléfono',
  uploadPassportPdf: 'Subir PDF del pasaporte',
  uploadPassportPdfHint: 'Un archivo con todas las páginas',
  passportExtractionNote:
    'Usaremos el pasaporte para completar los datos en las siguientes pantallas. Puedes revisarlos y corregirlos.',
  passportAddLaterNote: 'También puedes introducir los datos y añadir el pasaporte más tarde.',
  passportEnterDetailsWithoutUpload: 'Introducir datos sin subir el pasaporte',
  passportContinueToDetails: 'Continuar con los datos',
  ndaActionBody: 'Revisa y firma el NDA de la producción.',
  personalActionBody: 'Confirma tus datos de solicitante para que podamos preparar tu expediente.',
  itineraryActionBody: 'Sube un CSV con tus vuelos, hotel y horarios de rodaje.',
  ready: 'Listo',
};
